export const IMMEDIATE_ATTENTION = 'IMMEDIATE ATTENTION';
export const ATTENTION_TODAY = 'ATTENTION TODAY';

export type AlertText = typeof IMMEDIATE_ATTENTION | typeof ATTENTION_TODAY;
